import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldShapeLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2978 2.1957C11.7505 2.02591 12.2495 2.02591 12.7022 2.1957L19.7022 4.8207C20.4829 5.11342 21 5.85967 21 6.69336V12.056C21 15.465 19.074 18.5814 16.0249 20.1059L12.6708 21.7829C12.2485 21.9941 11.7515 21.9941 11.3292 21.7829L7.97508 20.1059C4.92602 18.5814 3 15.465 3 12.056V6.69336C3 5.85967 3.51715 5.11342 4.29775 4.8207L11.2978 2.1957ZM12 4.06836L5 6.69336V12.056C5 14.7074 6.49802 17.1313 8.8695 18.317L12 19.8823L15.1305 18.317C17.502 17.1313 19 14.7074 19 12.056V6.69336L12 4.06836Z",
		fill: "currentColor"
	})
});
export default SvgShieldShapeLine;
